/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What JSON shape does it expect?`)
};

const es_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué estructura JSON espera?`)
};

const de_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche JSON-Struktur wird erwartet?`)
};

const nl_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke JSON-vorm verwacht het?`)
};

const fr_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle forme JSON est attendue ?`)
};

const it_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale forma JSON si aspetta?`)
};

const pt_br2_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formato JSON ele espera?`)
};

const pt_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formato JSON é esperado?`)
};

const ja_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのような JSON 形式を期待しますか？`)
};

const zh_cj_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它期望的 JSON 结构是什么样的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_faq2_q", locale)
	if (locale === "en") return en_cj_faq2_q(inputs)
	if (locale === "es") return es_cj_faq2_q(inputs)
	if (locale === "de") return de_cj_faq2_q(inputs)
	if (locale === "nl") return nl_cj_faq2_q(inputs)
	if (locale === "fr") return fr_cj_faq2_q(inputs)
	if (locale === "it") return it_cj_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_cj_faq2_q(inputs)
	if (locale === "pt") return pt_cj_faq2_q(inputs)
	if (locale === "ja") return ja_cj_faq2_q(inputs)
	return zh_cj_faq2_q(inputs)
};